import React from "react";
import ClassNames from "classnames";
import "./clickToCall.css";
//Shared
import Portal from "../Portal";

import { LocaleConsumer } from "../Layout";

import globalContent from "../../../content/global";
import { getStaticData } from "../../helperFunctions";

const BDNumber = "+63288629551";
class Test extends React.Component {
  constructor(props) {
    super(props);
    this.compRef = React.createRef();
    this.compRef.current = true;
    this.handleClick = this.handleClick.bind(this);
  }
  state = {
    loaded: false,
    active: false
  };

  handleClick(numberToCall, locale) {
    this.setState({
      active: true
    });
    if (this.compRef.current) {
      import("./clickToCall").then(CallPage => {
        //console.log("localeeee", locale)
        new CallPage.default(
          this.compRef,
          this.state.loaded,
          numberToCall,
          this.props.options,
          this.props.BDNumber,
          this.props.hrefCall,
          this.props.officeTitle,
          this.props.onCallDisconnect,
          getStaticData(globalContent.get_in_touch, locale).call_popup
        );
        this.compRef.current = false;
        this.setState({
          loaded: true
        });
      });
    }
  }

  render() {
    const { numberToCall } = this.props;
    return (
      <LocaleConsumer>
        {({ locale }) => (
          <>
            <span
              className="click-to-call-button-TD"
              onClick={() => {
                // BD Team from Philippines request:
                // If it's Philippines, change career number to BD Team
                let number = this.props.officeTitle.includes("Philippines")
                  ? BDNumber
                  : numberToCall;
                this.handleClick(number, locale);
              }}
            >
              {numberToCall}
            </span>
            <Portal>
              {!this.state.loaded && (
                <div
                  className={ClassNames("clickToCallContainer", {
                    clickToCallActive: this.state.active
                  })}
                >
                  {/* <div>Loading...</div> */}
                </div>
              )}
            </Portal>
          </>
        )}
      </LocaleConsumer>
    );
  }
}

export default Test;
